import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-[#222629] border-t border-gray-700 pt-12 pb-8">
            <div className="container mx-auto px-4 md:px-6">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-8">
                    {/* Logo & Description */}
                    <div className="col-span-2 md:col-span-2">
                        <div className="flex items-center space-x-3 mb-6">
                            <Link to="/" className="flex items-center">
                                <img 
                                    src="/logo-light.png" 
                                    alt="Hunar Pool" 
                                    className="h-8 w-auto" 
                                    draggable="false"
                                />
                            </Link>
                        </div>
                        <p className="text-gray-400 mb-6 max-w-md">
                            We connect talented professionals with career opportunities that truly fit their skills, goals, and aspirations. Our platform is designed with job seekers at the center, helping them discover roles where they can grow, contribute, and thrive.
                        </p>
                        <div className="flex space-x-4">
                            <a href="https://www.linkedin.com/company/hunar-pool" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-[#0096C7] transition">
                                <i className="fab fa-linkedin-in text-lg"></i>
                            </a>
                            <a href="https://www.facebook.com/HunarPoolCareers" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-[#0096C7] transition">
                                <i className="fab fa-facebook-f text-lg"></i>
                            </a>
                            <a href="https://www.instagram.com/hunar_pool" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-[#0096C7] transition">
                                <i className="fab fa-instagram text-lg"></i>
                            </a>
                        </div>
                    </div>
                    
                    {/* For Job Seekers Links */}
                    <div className="col-span-1">
                        <h3 className="text-lg font-bold text-white mb-6">For Job Seekers</h3>
                        <ul className="space-y-3">
                            <li><Link to="/jobs" className="text-gray-400 hover:text-[#0096C7] transition">Browse Jobs</Link></li>
                            <li><Link to="/ai-match-profile" className="text-gray-400 hover:text-[#0096C7] transition">AI Match Profile</Link></li>
                            {/* <li><Link to="/career-advice" className="text-gray-400 hover:text-[#0096C7] transition">Career Advice</Link></li> */}
                            <li><Link to="/resume-builder" className="text-gray-400 hover:text-[#0096C7] transition">Resume Builder</Link></li>                            
                        </ul>
                    </div>
                    
                    {/* Company Links */}
                    <div className="col-span-1">
                        <h3 className="text-lg font-bold text-white mb-6">Company</h3>
                        <ul className="space-y-3">
                            <li><Link to="/about" className="text-gray-400 hover:text-[#0096C7] transition">About Us</Link></li>
                            <li><Link to="/contact" className="text-gray-400 hover:text-[#0096C7] transition">Contact</Link></li>                            
                            <li><Link to="/blog" className="text-gray-400 hover:text-[#0096C7] transition">Blog</Link></li>                            
                        </ul>
                    </div>
                </div>
                
                <div className="border-t border-gray-800 pt-8">
                    <div className="flex flex-col md:flex-row justify-between items-center">
                        <div className="text-gray-500 text-sm mb-4 md:mb-0">
                            &copy; {currentYear} Hunar Pool. All rights reserved.
                        </div>
                        <div className="flex items-center space-x-6 text-sm text-gray-400">
                            <Link to="/privacy-policy" className="hover:text-[#0096C7] transition">Privacy Policy</Link>
                            <Link to="/terms-and-conditions" className="hover:text-[#0096C7] transition">Terms & Conditions</Link>
                            {/* <Link to="/cookies" className="hover:text-[#0096C7] transition">Cookie Policy</Link> */}
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;